import {
  LineChart,
  Landmark,
  Gauge,
  Calculator,
  Sigma,
  MonitorSmartphone,
  Megaphone,
  Sparkles,
} from "lucide-react";

// Non-translatable / structural data shared across languages.
export const SERVICE_ICONS = [
  LineChart,
  Landmark,
  Gauge,
  Calculator,
  Sigma,
  MonitorSmartphone,
  Megaphone,
  Sparkles,
];

export const CONTACT = {
  address: "234 Cité Golf, Cambérène, Dakar",
  phone: "+221 77 108 75 61",
  phoneHref: "+221771087561",
  email: "contact@dsexpert.online",
};

export const LEGAL = {
  rccm: "SN-DKR-2019-B-3639",
  ninea: "007205869",
  capital: "25 000 000 FCFA",
};

export const FOUNDER_STATIC = {
  name: "M. Denis SYLLA",
  photo: "/founder-denis-sylla.jpg?v=2",
};

export const BRAND = {
  name: "DS EXPERT",
  fullName: "DS EXPERT SUARL",
  logo: "/ds-expert-logo.png",
};
